import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ButtonWrapper,
} from '../../../components';

import './style.scss';

const ParagraphCtaBlock = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  return (
    <Container className="ParagraphCtaBlock">
      <div className="row">
        <div className="col-12">
          <div className="ParagraphCtaBlock__inner">
            <h1 className="ParagraphCtaBlock__title">{title}</h1>
            <ButtonWrapper type="primary" href={linkUri}>{linkTitle}</ButtonWrapper>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphCtaBlock;
